﻿
import SliderComponent from './components/display/slider-component';
window.ONEONEROA = {};

new SliderComponent('*[data-component="c-slider-component"]');

ONEONEROA.Navigation = (function () {

    return {
        init: function () {           
            var $body = $('body');
            var $modal = $('.oneoneroa-menu-modal');
            var $close = $('.oneoneroa-menu-close');
            var $navbutton = $('.oneoneroa-menu-button');
            var $navbar = $('.oneoneroa-navbar');

            var navIsDark = ($(window).scrollTop() === 0);
            $navbar.toggleClass("dark", navIsDark); //toggle the class on or off depending on the bool paramater passed to the function

            function setNavStateToDark() {
                navIsDark = true;
                if (!$navbar.hasClass('dark')) {
                    $navbar.addClass('dark');                    
                }
            }

            function setNavStateToWhite() {
                $navbar.removeClass('dark');
                navIsDark = false;
            }

            $navbutton.on('click', function (e) {
                e.preventDefault();
                $modal.addClass('is-open');
                $close.removeClass('hidden');
                $navbutton.addClass('hidden');
                $body.addClass('overflow-hidden');
                setNavStateToDark();
            });

            $close.on('click', function (e) {
                e.preventDefault();
                $modal.removeClass('is-open');
                $close.addClass('hidden');
                $navbutton.removeClass('hidden');
                $body.removeClass('overflow-hidden');

                if ($(window).scrollTop() !== 0) { setNavStateToWhite(); }
            });

            $(window).scroll(function () {
                var height = $(window).scrollTop();

                if (height === 0) {
                    setNavStateToDark();
                }

                if (height > 0 && navIsDark) {
                    setNavStateToWhite();
                }
            });
        }
    };
}());

ONEONEROA.Navigation.init();